import { exists } from "../../../_helper/util.helper";

/**
 * A configuration for the public record search box.
 */
export class PublicRecordConfigModel {

  public label: string = 'Public Records';

  public provider: 'CRS' | 'Teranet' = 'Teranet';

  //makes all the data from the provider readonly
  public allReadonly: boolean = false;
  public readonly: string[] = [];
  public excludeReadonly: string[] = [];
  public readonlyFilter: Filter[] = [];

  //makes all the data from the provider hidden from the user
  public allHidden: boolean = false;
  public hide: string[] = [];
  public excludeHide: string[] = [];
  public hideFilter: Filter[] = [];

  constructor(model?: Partial<PublicRecordConfigModel>) {
    if (model) {
      for (let key in this as PublicRecordConfigModel)
        if (exists(model[key]))
          this[key] = model[key];
      if (model.readonly?.length) this.readonly = [ ...model.readonly ];
      if (model.excludeReadonly?.length) this.excludeReadonly = [ ...model.excludeReadonly ];
      if (model.readonlyFilter?.length) this.readonlyFilter = model.readonlyFilter.map(f => ({ ...f }));
      if (model.hide?.length) this.hide = [ ...model.hide ];
      if (model.excludeHide?.length) this.excludeHide = [ ...model.excludeHide ];
      if (model.hideFilter?.length) this.hideFilter = model.hideFilter.map(f => ({ ...f }));
    }
  }
}

type Filter = {
  target: string;
  field: string;
  filter: '==' | '!=';
  value: string;
}